module.exports = __webpack_public_path__ + "img/app-store.71597086.png";